import { gql } from '@apollo/client';

const CONFIRM_MESSAGE_READ = gql`
  mutation ConfirmDirectMessageRead($messageId: Int!) {
    directMessageContext {
      confirmMessageRead(messageId: $messageId)
    }
  }
`;

export default CONFIRM_MESSAGE_READ;
